module.exports = __webpack_public_path__ + "media/images/river-aux-690a787843f224970ddd0269a9e0223c.png";